import React from 'react'
import {FormattedMessage} from 'react-intl'
import CheckboxCheckedImage from 'assets/icons/checkbox-checked'
import CheckboxUnCheckedImage from 'assets/icons/checkbox-unchecked'

import {
  ErrorText,
  CheckedIcon,
  CheckBoxWrapper,
  CheckBoxContainer,
  CheckBoxLabel,
  OptionalText
} from './style'

export default function Checkbox({
  label,
  checked,
  onChange,
  dataTest,
  error,
  field,
  disabled,
  isOptional = false
}) {
  const shouldRenderLabel = Boolean(label) || isOptional

  return (
    <>
      <CheckBoxContainer
        aria-label={label}
        data-testid={dataTest || 'test-checkbox'}
        disabled={disabled}
        hasLabel={shouldRenderLabel}
        onClick={disabled ? undefined : onChange}
      >
        <CheckBoxWrapper
          data-testid='test-checkbox-wrapper'
          disabled={disabled}
          hasLabel={shouldRenderLabel}
          onClick={disabled ? undefined : onChange}
          data-test={dataTest}
        >
          {checked ? <CheckedIcon data-testid='test-checked-icon' disabled={disabled}><CheckboxCheckedImage /></CheckedIcon> : <CheckboxUnCheckedImage />}
        </CheckBoxWrapper>
        {shouldRenderLabel && (
          <CheckBoxLabel>
            <span>{label}</span>
            {isOptional && (
              <OptionalText>
                <FormattedMessage id='optional' />
              </OptionalText>
            )}
          </CheckBoxLabel>
        )}
      </CheckBoxContainer>
      {error && error.field === field && (
        <ErrorText data-test="validation-error-message" data-testid="test-error">
          <FormattedMessage id={error.error} />
        </ErrorText>
      )}
    </>
  )
}

import PropTypes from 'prop-types';

Checkbox.propTypes = {
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  dataTest: PropTypes.string,
  error: PropTypes.shape({
    field: PropTypes.string,
    error: PropTypes.string
  }),
  field: PropTypes.string,
  disabled: PropTypes.bool,
  isOptional: PropTypes.bool
};
